(() => {
  const FADE_MS = 200;

  const preloadImage = (src) => {
    if (!src) return;
    const image = new Image();
    image.src = src;
  };

  const init = (root) => {
    const rosterEl = root.querySelector('[data-how-ff-roster]');
    const photo = root.querySelector('.how-ff__photo');
    const nameEl = root.querySelector('[data-how-ff-name]');
    const prev = root.querySelector('[data-how-ff-prev]');
    const next = root.querySelector('[data-how-ff-next]');
    if (!rosterEl || !photo || !nameEl || !prev || !next) return;

    let roster = [];
    try {
      roster = JSON.parse(rosterEl.textContent || '[]');
    } catch (error) {
      console.warn('How it works firefighter roster could not be parsed', error);
      return;
    }

    roster = roster.filter((item) => item && item.name && item.image);
    if (!roster.length) return;

    let index = roster.findIndex((item) => item.slug === 'micky');
    if (index < 0) index = 0;
    let busy = false;

    const preloadAround = (current) => {
      if (roster.length < 2) return;
      preloadImage(roster[(current - 1 + roster.length) % roster.length]?.image);
      preloadImage(roster[(current + 1) % roster.length]?.image);
    };

    const show = (nextIndex) => {
      if (busy || nextIndex === index || !roster[nextIndex]) return;
      const item = roster[nextIndex];
      const current = photo.querySelector('img');

      if (!item.image || !current) {
        index = nextIndex;
        nameEl.textContent = item.name;
        preloadAround(index);
        return;
      }

      busy = true;
      const incoming = document.createElement('img');
      incoming.alt = item.name || '';
      incoming.width = 120;
      incoming.height = 120;
      incoming.className = 'is-incoming';
      incoming.src = item.image;
      photo.appendChild(incoming);

      let settled = false;
      const finish = () => {
        if (settled) return;
        settled = true;
        if (current.isConnected) current.remove();
        busy = false;
        preloadAround(index);
      };

      const reveal = () => {
        index = nextIndex;
        let started = false;
        const beginFade = () => {
          if (started) return;
          started = true;
          nameEl.textContent = item.name;
          incoming.classList.remove('is-incoming');
          incoming.addEventListener(
            'transitionend',
            (event) => {
              if (event.propertyName !== 'opacity') return;
              finish();
            },
            { once: true }
          );
          window.setTimeout(finish, FADE_MS + 80);
        };
        requestAnimationFrame(() => requestAnimationFrame(beginFade));
        window.setTimeout(beginFade, 40);
      };

      if (incoming.complete) {
        if (incoming.naturalWidth) reveal();
        else {
          incoming.remove();
          busy = false;
        }
      } else {
        incoming.addEventListener('load', reveal, { once: true });
        incoming.addEventListener(
          'error',
          () => {
            incoming.remove();
            busy = false;
          },
          { once: true }
        );
      }
    };

    prev.addEventListener('click', () => {
      show((index - 1 + roster.length) % roster.length);
    });
    next.addEventListener('click', () => {
      show((index + 1) % roster.length);
    });
    preloadAround(index);
  };

  document.querySelectorAll('[data-how-ff]').forEach(init);
})();
